export default __webpack_public_path__ + "static/media/kai_head.6f626c2d.png";